export const cn = (...classes: (string | boolean | undefined)[]): string => {
    let result = '';

    for (const cls of classes) {
        if (typeof cls === 'string') {
            result += result ? ' ' + cls : cls;
        }
    }

    return result;
};
